import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "heart_fill",
  "use": "heart_fill-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" id=\"heart_fill\"><path fill=\"currentColor\" fill-rule=\"evenodd\" stroke=\"currentColor\" d=\"M20 28l-7.67-8.13a4.665 4.665 0 01-.851-5.32h0c1.122-2.279 3.847-3.2 6.09-2.062.436.22.834.513 1.179.864L20 14.624l1.252-1.272a4.487 4.487 0 016.419 0c.345.35.631.754.85 1.197h0a4.665 4.665 0 01-.85 5.322L20 28z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol